$(function () {
  if (!customElements.get('product-image-zoom')) {
    customElements.define(
      'product-image-zoom',
      class ProductImageZoom extends HTMLElement {
        constructor() {
          super();
          this.initState();
        }

        // 初始化状态变量
        initState() {
          this.isPlaying = false;
          this.isPlayingLocked = false; // 添加锁变量
          this.playInterval = null;
          this.currentIndex = 0;
          this.currentScale = 1;
          this.draggableInstance = null;
          this.hammerInstance = null;
          this.currentRotation = 0;
          this.mainSwiper = null;
          this.thumbsSwiper = null;
          this.eventListeners = new Map();
          this.imagesArray = []; // 添加图片数组存储
          this.isPackageMode = false; // 添加标记来区分当前模式
          this.hammerInstances = new Map();
        }

        // 添加设置模式的方法
        setMode(isPackage) {
          this.isPackageMode = isPackage;
        }

        // 添加 setImages 方法
        setImages(images) {
          if (!Array.isArray(images)) {
            console.error('setImages: images parameter must be an array');
            return;
          }

          if (images.length === 0) {
            console.warn('setImages: empty images array');
            return;
          }

          this.imagesArray = images;

          // 更新总数显示
          const totalNumSpan = this.querySelector('.current-total-num');
          if (totalNumSpan) {
            const productMedia = this.querySelector('.product-media');
            const packageMedia = this.querySelector('.package-media');

            try {
              if (this.isPackageMode && packageMedia && packageMedia.textContent) {
                // 如果是 package 模式，显示 package 数据的总数
                const packageData = JSON.parse(packageMedia.textContent);
                totalNumSpan.textContent = Object.keys(packageData).length;
                console.log('Package mode, total:', Object.keys(packageData).length);
              } else if (productMedia && productMedia.textContent) {
                // 否则显示 product 数据的总数
                const productData = JSON.parse(productMedia.textContent);

                const imageCount = productData.filter((media) => media.media_type === 'image').length;
                totalNumSpan.textContent = imageCount;
              }
            } catch (error) {
              console.error('Error updating total number:', error);
              // 使用传入的 images 数组长度作为后备
              totalNumSpan.textContent = images.length;
            }
          }
        }

        connectedCallback() {
          this.initElements();
          this.initSwipers();
          this.bindEvents();
          this.shareCopy();
        }
        shareCopy() {
          const shareCopyIcon = this.querySelector('.share-copy-icon');
          if (shareCopyIcon) {
            shareCopyIcon.addEventListener('click', () => {
              const url = window.location.href;
              navigator.clipboard.writeText(url);
              const $copyText = $(this.querySelectorAll('[data-copy-text]'));
              $copyText.on('click', function () {
                _this.copyText($(this).attr('data-copy-text'));
                _this.showMessage('文本已复制');
              });
            });
          }
        }
        // 初始化DOM元素
        initElements() {
          this.$productImageZoom = this.querySelector('.product-image-zoom');
          this.$productMedia = this.$productImageZoom.querySelector('.product-media');
          this.$modal = this.querySelector('.preview-modal');
          this.$previewContainer = this.querySelector('.preview-container');
          this.$previewImage = this.querySelector('.preview-image');
          this.$closeBtn = this.querySelector('.close-btn');
          this.$images = this.querySelectorAll('.image-item img');

          this.$prevBtn = this.querySelector('#prevImage');
          this.$nextBtn = this.querySelector('#nextImage');
          this.$previewImageContainer = this.querySelector('.preview-image-container');
          this.$playBtn = this.querySelector('#playBtn');

          this.$controls = {
            zoomIn: this.querySelector('#zoomIn'),
            zoomOut: this.querySelector('#zoomOut'),
            rotateLeft: this.querySelector('#rotateLeft'),
            rotateRight: this.querySelector('#rotateRight'),
            fullscreen: this.querySelector('#fullscreenBtn'),
            fitWindow: this.querySelector('#fitWindowBtn'),
            toggleThumbs: this.querySelector('#toggleThumbs'),
            share: this.querySelector('#shareBtn'),
          };
        }

        // 初始化 Swiper
        initSwipers() {
          // 清理已存在的 Swiper 实例
          if (this.thumbsSwiper) this.thumbsSwiper.destroy();
          if (this.mainSwiper) this.mainSwiper.destroy();

          // 检查必要的DOM元素是否存在
          const thumbsContainer = this.querySelector('.thumbsSwiper');
          const mainContainer = this.querySelector('.mainSwiper');

          if (!thumbsContainer || !mainContainer) {
            console.warn('Swiper containers not found');
            return null;
          }

          try {
            // 初始化缩略图 Swiper
            this.thumbsSwiper = new Swiper(thumbsContainer, {
              spaceBetween: 10,
              slidesPerView: 'auto',
              freeMode: true,
              watchSlidesProgress: true,
              loop: true,
            });

            // 默认隐藏缩略图
            if (thumbsContainer) {
              thumbsContainer.classList.add('hidden');
            }

            // 初始化主 Swiper
            this.mainSwiper = new Swiper(mainContainer, {
              spaceBetween: 10,
              effect: 'fade',
              fadeEffect: { crossFade: true },
              loop: true,
              thumbs: { swiper: this.thumbsSwiper },
              on: {
                init: (swiper) => {
                  if (swiper && swiper.slides && swiper.slides.length > 0) {
                    this.currentIndex = swiper.activeIndex;
                    setTimeout(() => {
                      this.resetImageState();
                      this.initDraggable();
                      this.addSlideClickEvent();
                    }, 0);
                  }
                },
                slideChange: (swiper) => {
                  if (!swiper || !swiper.slides) return;

                  this.currentIndex = swiper.realIndex;

                  this.querySelector('.current-num').textContent = this.currentIndex + 1;

                  setTimeout(() => {
                    this.resetImageState();
                    this.initDraggable();
                  }, 100);
                },
              },
            });

            return this.mainSwiper;
          } catch (error) {
            console.error('Error initializing Swiper:', error);
            return null;
          }
        }
        addSlideClickEvent() {
          // 先移除所有已存在的点击事件监听器
          const slides = this.mainSwiper.slides;
          slides.forEach((slide) => {
            if (slide.dataset.hasClickListener === 'true') {
              const img = slide.querySelector('img');
              if (img) {
                const newImg = img.cloneNode(true);
                img.parentNode.replaceChild(newImg, img);
              }
            }
          });

          // 添加新的点击事件监听器，但不包含放大功能
          slides.forEach((slide) => {
            const img = slide.querySelector('img');
            if (img) {
              const handleClick = () => {
                const realIndex = this.mainSwiper.realIndex;

                // 移除点击放大功能
              };

              img.addEventListener('click', handleClick);
              slide.dataset.hasClickListener = 'true';
            }
          });
        }
        // 重置图片状态
        resetImageState() {
          // 添加安全检查
          if (!this.mainSwiper || !this.mainSwiper.slides || !this.mainSwiper.activeIndex) {
            return;
          }

          this.currentScale = 1;
          this.currentRotation = 0;

          const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
          if (!activeSlide) return;

          const activeImage = activeSlide.querySelector('img');
          if (activeImage) {
            gsap.set(activeImage, {
              scale: 1,
              rotation: 0,
            });
          }
        }

        // 绑定事件
        bindEvents() {
          this.bindImageEvents();
          this.bindControlEvents();
          this.bindCloseBtnEvents();
        }

        bindCloseBtnEvents() {
          this.$closeBtn?.addEventListener('click', () => {
            this.closePreview();
          });
        }
        // 绑定图片相关事件

        bindImageEvents() {
          if (!this.$images || this.$images.length === 0) {
            console.warn('No images found to bind events to');
            return;
          }

          this.$images.forEach((img, index) => {
            img.addEventListener('click', () => {
              this.openPreview(index);
            });
          });

          // 添加预览图片的点击缩放功能
          console.log(this.$previewImage, 'this.$previewImage');
          if (this.$previewImage) {
            this.$previewImage.addEventListener('click', (e) => {
              console.log('点击了');
              // 如果点击的是控制按钮，不执行缩放
              if (e.target.closest('.preview-controls')) return;

              // 使用现有的 zoom 方法
              if (this.currentScale === 1) {
                // 放大 - 相当于点击 zoomIn
                this.zoom(0.2);
              } else {
                // 缩小 - 相当于点击 zoomOut
                this.zoom(-0.2);
              }
            });
          }
        }

        // 绑定控制按钮事件
        bindControlEvents() {
          // 播放控制
          this.$playBtn?.addEventListener('click', () => {
            this.togglePlay();
          });

          // 缩放控制
          this.$controls.zoomIn?.addEventListener('click', () => this.zoom(0.2));
          this.$controls.zoomOut?.addEventListener('click', () => this.zoom(-0.2));

          // 旋转控制
          this.$controls.rotateLeft?.addEventListener('click', () => this.rotateImage(-1));
          this.$controls.rotateRight?.addEventListener('click', () => this.rotateImage(1));

          // 其他控制
          this.bindFullscreenEvents();
          this.bindNavigationEvents();
          this.bindThumbsEvents();
          this.bindShareEvents();
          this.bindFitWindowEvents();
        }

        // 添加适应窗口事件
        bindFitWindowEvents() {
          this.$controls.fitWindow?.addEventListener('click', () => {
            const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
            const activeImage = activeSlide.querySelector('img');
            const adaptIcon = this.$controls.fitWindow?.querySelector('.adapt-icon');
            const proportionIcon = this.$controls.fitWindow?.querySelector('.proportion-icon');
            if (!activeImage) return;

            // 获取容器和图片的尺寸
            const containerWidth = window.innerWidth;
            const containerHeight = window.innerHeight;
            const imageWidth = activeImage.naturalWidth;
            const imageHeight = activeImage.naturalHeight;

            // 计算宽高比
            const containerRatio = containerWidth / containerHeight;
            const imageRatio = imageWidth / imageHeight;

            // 计算适合屏幕的缩放比例
            const fitScale =
              imageRatio > containerRatio
                ? containerWidth / activeImage.offsetWidth
                : containerHeight / activeImage.offsetHeight;

            // 根据当前状态决定目标缩放比例
            let targetScale;
            if (this.currentScale === 1) {
              // 第一次点击：缩放到适合屏幕的大小
              targetScale = fitScale;
              adaptIcon.classList.toggle('hidden');
              proportionIcon.classList.toggle('hidden');
            } else {
              // 再次点击：恢复到原始大小
              targetScale = 1;
              adaptIcon.classList.toggle('hidden');
              proportionIcon.classList.toggle('hidden');
            }

            // 保存新的缩放值
            this.currentScale = targetScale;

            gsap.to(activeImage, {
              scale: targetScale,
              x: 0,
              y: 0,
              duration: 0.3,
              ease: 'power2.out',
              transformOrigin: 'center center',
              onStart: () => {
                if (targetScale > 1) {
                  activeImage.classList.add('cursor-zoom-out');
                  activeImage.classList.remove('cursor-zoom-in');
                  this.mainSwiper.allowTouchMove = false;
                } else {
                  activeImage.classList.remove('cursor-zoom-out');
                  activeImage.classList.add('cursor-zoom-in');
                  this.mainSwiper.allowTouchMove = true;
                }
              },
              onComplete: () => {
                if (this.draggableInstance) {
                  if (targetScale > 1) {
                    this.draggableInstance.enable();
                    activeImage.classList.add('zoomed');
                  } else {
                    this.draggableInstance.disable();
                    activeImage.classList.remove('zoomed');
                  }
                }
              },
            });
          });
        }

        // 添加设备检测函数
        isMobile() {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        }

        // 修改 initHammer 方法
        initHammer() {
          // 为每个幻灯片添加手势支持
          this.mainSwiper.slides.forEach((slide) => {
            const image = slide.querySelector('img');
            if (!image) return;

            const hammer = new Hammer.Manager(image, {
              touchAction: 'pan-x pan-y',
            });

            // 添加手势识别器
            if (this.isMobile()) {
              hammer.add(new Hammer.Pinch());
              hammer.add(
                new Hammer.Pan({
                  direction: Hammer.DIRECTION_ALL,
                  threshold: 0,
                })
              );
              // 添加双击识别器
              hammer.add(new Hammer.Tap({ event: 'doubletap', taps: 2, interval: 300 }));

              let startScale = 1;
              let lastScale = 1;
              let lastPosX = 0;
              let lastPosY = 0;
              let isDragging = false;

              // 处理双击事件
              hammer.on('doubletap', (e) => {
                e.preventDefault();

                // 添加过渡效果
                image.style.transition = 'transform 0.3s ease-out';

                if (this.currentScale === 1) {
                  // 双击放大到3倍
                  this.currentScale = 3;
                  image.style.transform = `scale(3)`;
                  this.mainSwiper.allowTouchMove = false;
                } else {
                  // 双击恢复原始大小
                  this.currentScale = 1;
                  image.style.transform = 'scale(1)';
                  this.mainSwiper.allowTouchMove = true;
                }

                // 延迟移除过渡效果
                setTimeout(() => {
                  image.style.transition = '';
                }, 300);
              });

              // 处理捏合缩放开始
              hammer.on('pinchstart', () => {
                startScale = this.currentScale || 1;
                lastScale = startScale;
                image.style.transition = 'none';
              });

              // 处理捏合缩放
              hammer.on('pinchmove', (e) => {
                const SCALE_SENSITIVITY = 0.3;
                const scaleDiff = (e.scale - 1) * SCALE_SENSITIVITY;
                const targetScale = startScale * (1 + scaleDiff * 2);
                const smoothScale = lastScale + (targetScale - lastScale) * 0.3;
                const newScale = Math.min(Math.max(smoothScale, 0.5), 3);

                this.currentScale = newScale;
                lastScale = newScale;

                const transform = window.getComputedStyle(image).transform;
                const matrix = new DOMMatrix(transform);
                const currentX = matrix.m41;
                const currentY = matrix.m42;

                image.style.transform = `translate(${currentX}px, ${currentY}px) scale(${newScale})`;
              });

              // 处理捏合缩放结束
              hammer.on('pinchend', () => {
                // 添加平滑过渡
                image.style.transition = 'transform 0.3s ease-out';

                // 如果缩放比例小于1，平滑回弹到1
                if (this.currentScale < 1) {
                  this.currentScale = 1;
                  image.style.transform = `translate(0px, 0px) scale(1)`;
                } else if (this.currentScale > 3) {
                  // 如果超过最大值，平滑回弹到最大值
                  this.currentScale = 3;
                  const transform = window.getComputedStyle(image).transform;
                  const matrix = new DOMMatrix(transform);
                  const currentX = matrix.m41;
                  const currentY = matrix.m42;
                  image.style.transform = `translate(${currentX}px, ${currentY}px) scale(3)`;
                }

                // 更新滑动器状态
                this.mainSwiper.allowTouchMove = this.currentScale <= 1;

                // 延迟移除过渡效果
                setTimeout(() => {
                  image.style.transition = '';
                }, 300);
              });

              // 处理拖动
              hammer.on('panstart', () => {
                if (this.currentScale > 1) {
                  isDragging = true;
                  const transform = window.getComputedStyle(image).transform;
                  const matrix = new DOMMatrix(transform);
                  lastPosX = matrix.m41;
                  lastPosY = matrix.m42;
                  image.style.transition = 'none';
                }
              });

              hammer.on('panmove', (e) => {
                if (isDragging && this.currentScale > 1) {
                  const newX = lastPosX + e.deltaX;
                  const newY = lastPosY + e.deltaY;

                  // 计算边界
                  const maxX = (image.offsetWidth * (this.currentScale - 1)) / 2;
                  const maxY = (image.offsetHeight * (this.currentScale - 1)) / 2;

                  // 限制移动范围
                  const boundedX = Math.max(-maxX, Math.min(maxX, newX));
                  const boundedY = Math.max(-maxY, Math.min(maxY, newY));

                  image.style.transform = `translate(${boundedX}px, ${boundedY}px) scale(${this.currentScale})`;
                }
              });

              hammer.on('panend', () => {
                if (isDragging) {
                  isDragging = false;
                  image.style.transition = 'transform 0.2s ease-out';
                  setTimeout(() => {
                    image.style.transition = '';
                  }, 200);
                }
              });
            }

            // 存储 hammer 实例以便清理
            if (!this.hammerInstances) {
              this.hammerInstances = new Map();
            }
            this.hammerInstances.set(image, hammer);
          });
        }

        // 修改 zoom 方法
        zoom(delta) {
          const newScale = this.currentScale + delta;
          if (newScale >= 1 && newScale <= 3) {
            this.currentScale = newScale;
            const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
            const activeImage = activeSlide.querySelector('img');
            const container = activeSlide.querySelector('.swiper-zoom-container');

            if (activeImage) {
              gsap.to(activeImage, {
                scale: this.currentScale,
                duration: 0.3,
              });

              // 更新拖拽边界
              if (this.draggableInstance) {
                this.draggableInstance.update();
              }

              // 更新鼠标样式
              if (container) {
                if (this.currentScale > 1) {
                  container.classList.remove('cursor-zoom-in');
                  container.classList.add('cursor-grab');
                } else {
                  container.classList.remove('cursor-grab', 'cursor-grabbing');
                  container.classList.add('cursor-zoom-in');
                }
              }
            }
          }
        }

        // 打开预览函数
        openPreview(index) {
          // 确保 imagesArray 有效
          if (!this.imagesArray || this.imagesArray.length === 0) {
            console.warn('No images to preview');
            return;
          }

          // 确保 modal 存在
          if (!this.$modal) {
            console.error('Modal element not found');
            return;
          }

          // 显示模态框
          this.$modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';

          // 清空现有内容
          const mainWrapper = this.querySelector('.mainSwiper .swiper-wrapper');
          const thumbsWrapper = this.querySelector('.thumbsSwiper .swiper-wrapper');

          if (!mainWrapper || !thumbsWrapper) {
            console.error('Swiper wrappers not found');
            return;
          }

          mainWrapper.innerHTML = '';
          thumbsWrapper.innerHTML = '';

          // 创建文档片段来提高性能
          const mainFragment = document.createDocumentFragment();
          const thumbsFragment = document.createDocumentFragment();

          // 添加图片到 Swiper
          this.imagesArray.forEach((imageObj) => {
            const imageSrc = Object.values(imageObj)[0];

            // 创建主图片幻灯片
            const mainSlide = document.createElement('div');
            mainSlide.className = 'swiper-slide';
            mainSlide.innerHTML = `
              <div class="flex items-center justify-center w-full h-full swiper-zoom-container cursor-zoom-in">
                <img src="${imageSrc}" alt="Preview" class="max-w-full max-h-full object-contain">
              </div>
            `;
            mainSlide.addEventListener('click', (e) => {
              const container = e.target.closest('.swiper-zoom-container');
              const img = container?.querySelector('img');
              if (!container || !img || e.target.closest('.preview-controls')) return;

              if (this.currentScale === 1) {
                this.zoom(0.2);
                container.classList.remove('cursor-zoom-in');
                container.classList.add('cursor-grab');
                // 启用拖拽
                if (!this.draggableInstance) {
                  this.draggableInstance = Draggable.create(img, {
                    type: 'x,y',
                    inertia: true,
                    bounds: container,
                    onDragStart: () => {
                      container.classList.remove('cursor-grab');
                      container.classList.add('cursor-grabbing');
                    },
                    onDragEnd: () => {
                      container.classList.remove('cursor-grabbing');
                      container.classList.add('cursor-grab');
                    },
                  })[0];
                } else {
                  this.draggableInstance.enable();
                }
              } else {
                this.zoom(-0.2);
                container.classList.remove('cursor-grab', 'cursor-grabbing');
                container.classList.add('cursor-zoom-in');
                // 禁用拖拽
                if (this.draggableInstance) {
                  this.draggableInstance.disable();
                }
              }
            });
            mainFragment.appendChild(mainSlide);

            // 创建缩略图幻灯片
            const thumbSlide = document.createElement('div');
            thumbSlide.className = 'swiper-slide';
            thumbSlide.innerHTML = `
              <svg class="border-path" viewBox="0 0 104 104">
                <rect x="1" y="1" width="102" height="102" rx="8" ry="8" pathLength="100" stroke-dasharray="100" stroke-dashoffset="100"/>
              </svg>
              <img src="${imageSrc}" alt="Thumbnail" class="thumbnail-img">
            `;
            thumbsFragment.appendChild(thumbSlide);
          });

          // 添加幻灯片到容器
          mainWrapper.appendChild(mainFragment);
          thumbsWrapper.appendChild(thumbsFragment);

          // 初始化 Swiper 并跳转到指定索引
          const swiperInstance = this.initSwipers();
          if (swiperInstance) {
            setTimeout(() => {
              if (swiperInstance.initialized) {
                swiperInstance.slideTo(index, 0);
                this.currentIndex = index;
                this.initHammer();
              }
            }, 100);
          }

          // 更新当前图片索引显示
          const currentNumSpan = this.querySelector('.current-num');
          if (currentNumSpan) {
            currentNumSpan.textContent = index + 1;
          }

          // 添加关闭预览的点击事件
          this.$modal.addEventListener('click', (e) => {
            if (e.target === this.$modal) {
              this.closePreview();
            }
          });
        }

        // 修改关闭预览方法
        closePreview() {
          if (!this.$modal) return;

          // 清理所有 hammer 实例
          if (this.hammerInstances) {
            this.hammerInstances.forEach((hammer) => {
              hammer.destroy();
            });
            this.hammerInstances.clear();
          }

          this.$modal.style.display = 'none';
          document.body.style.overflow = '';
          this.resetTransform();
          this.stopAutoPlay();
        }

        // 绑定全屏事件
        bindFullscreenEvents() {
          this.$controls.fullscreen?.addEventListener('click', () => {
            const fullIcon = this.$controls.fullscreen?.querySelector('.full-icon');
            const shrinkIcon = this.$controls.fullscreen?.querySelector('.shrink-icon');
            if (!document.fullscreenElement) {
              document.documentElement.requestFullscreen();
              fullIcon.classList.toggle('hidden');
              shrinkIcon.classList.toggle('hidden');
            } else {
              document.exitFullscreen();
              fullIcon.classList.toggle('hidden');
              shrinkIcon.classList.toggle('hidden');
            }
          });
        }

        // 绑定导航事件
        bindNavigationEvents() {
          this.$prevBtn?.addEventListener('click', () => {
            this.stopAutoPlay();
            this.mainSwiper?.slidePrev();
          });
          this.$nextBtn?.addEventListener('click', () => {
            this.stopAutoPlay();
            this.mainSwiper?.slideNext();
          });
        }

        // 绑定缩略图事件
        bindThumbsEvents() {
          // 默认隐藏
          let isThumbsVisible = false;
          const thumbsContainer = this.querySelector('.thumbsSwiper');

          this.$controls.toggleThumbs?.addEventListener('click', () => {
            isThumbsVisible = !isThumbsVisible;
            thumbsContainer.classList.toggle('hidden');
          });
        }

        // 绑定分享事件
        bindShareEvents() {
          const shareModal = this.querySelector('.share-modal');
          const closeShareBtn = this.querySelector('.close-share-btn');
          const shareOptions = this.querySelectorAll('.share-btn');

          this.$controls.share?.addEventListener('click', () => {
            shareModal.style.display = 'flex';
          });

          closeShareBtn?.addEventListener('click', () => {
            shareModal.style.display = 'none';
          });

          shareModal?.addEventListener('click', (e) => {
            if (e.target === shareModal) {
              shareModal.style.display = 'none';
            }
          });

          shareOptions.forEach((btn) => {
            btn.addEventListener('click', () => {
              const platform = btn.dataset.platform;
              const currentImage = this.$images[this.currentIndex].src;

              // 这里可以根据不同平台实现具体的分享逻辑
              switch (platform) {
                case 'wechat':
                  break;
                case 'weibo':
                  break;
                case 'qq':
                  break;
              }

              shareModal.style.display = 'none';
            });
          });
        }

        // 初始化拖动功能
        initDraggable() {
          // 先清理已存在的实例
          if (this.draggableInstance) {
            this.draggableInstance.kill();
          }

          // 添加安全检查
          if (!this.mainSwiper || !this.mainSwiper.slides) {
            console.warn('Swiper not properly initialized');
            return;
          }

          const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
          if (!activeSlide) {
            console.warn('No active slide found');
            return;
          }

          const activeImage = activeSlide.querySelector('img');
          if (!activeImage) {
            console.warn('No image found in active slide');
            return;
          }

          try {
            this.draggableInstance = Draggable.create(activeImage, {
              type: 'x,y',
              inertia: true,
              bounds: activeSlide,
              zIndexBoost: false,
              onClick: () => false,
              onDragStart: () => {
                if (this.currentScale <= 1) return false;
                activeImage.classList.add('dragging');
                activeImage.classList.add('cursor-grabbing');
              },
              onDrag: () => {
                if (this.currentScale > 1) {
                  activeImage.classList.add('zoomed');
                }
              },
              onDragEnd: () => {
                activeImage.classList.remove('dragging');
                if (this.currentScale > 1) {
                  activeImage.classList.add('zoomed');
                  activeImage.classList.remove('cursor-grabbing');
                  activeImage.classList.add('cursor-grab');
                }
              },
            })[0];

            // 根据缩放状态设置拖动
            if (this.currentScale <= 1) {
              this.draggableInstance.disable();
              activeImage.classList.remove('zoomed');
            } else {
              this.draggableInstance.enable();
              activeImage.classList.add('zoomed');
            }
          } catch (error) {
            console.error('Error initializing Draggable:', error);
          }
        }

        // 更新控制按钮状态
        updateControls() {
          this.$prevBtn.disabled = this.currentIndex === 0;
          this.$nextBtn.disabled = this.currentIndex === this.$images.length - 1;
        }

        // 修改切换图片函数
        switchImage(direction) {
          let newIndex;
          if (typeof direction === 'number') {
            // 如果传入的是数字，表示相对位移
            newIndex = this.currentIndex + direction;
            if (newIndex >= this.$images.length) {
              newIndex = 0;
            } else if (newIndex < 0) {
              newIndex = this.$images.length - 1;
            }
          } else {
            // 如果传入的不是数字，则直接作为目标索引
            newIndex = parseInt(direction);
          }

          if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.$images.length) {
            // 创建新图片元素用于预加载
            const nextImage = new Image();
            nextImage.src = this.$images[newIndex].src;

            nextImage.onload = () => {
              // 创建新的图片元素
              const newPreviewImage = document.createElement('img');
              newPreviewImage.className = this.$previewImage.className;
              newPreviewImage.src = nextImage.src;
              newPreviewImage.classList.add('absolute', 'opacity-0');

              // 将新图片添加到容器中
              this.$previewContainer.appendChild(newPreviewImage);

              // 更新当前索引（提前更新索引）
              this.currentIndex = newIndex;
              // 更新缩略图激活状态
              this.updateThumbnailActive();
              // 更新控制按钮状态
              this.updateControls();

              // 淡出当前图片，同时淡入新图片
              gsap.to(this.$previewImage, {
                opacity: 0,
                duration: 0.5,
                onComplete: () => {
                  // 确保旧图片还在容器中才移除
                  if (this.$previewImage.parentNode === this.$previewContainer) {
                    this.$previewContainer.removeChild(this.$previewImage);
                  }
                  // 更新previewImage引用
                  this.$previewImage = newPreviewImage;

                  // 重新初始化拖动和手势
                  this.initDraggable();
                  this.initHammer();
                },
              });

              gsap.to(newPreviewImage, {
                opacity: 1,
                duration: 0.5,
              });
            };
          }
        }

        // 新增更新缩略图激活状态的函数
        updateThumbnailActive() {
          const thumbnails = document.querySelectorAll('.thumbnail-item');
          thumbnails.forEach((thumbnail, index) => {
            if (index === this.currentIndex) {
              thumbnail.classList.add('active');
            } else {
              thumbnail.classList.remove('active');
            }
          });
        }

        // 重置位置
        resetPosition() {
          gsap.to(this.$previewImage, {
            x: 0,
            y: 0,
            duration: 0.3,
          });
          if (this.draggableInstance) {
            this.draggableInstance.update();
          }
        }

        // 重置变换
        resetTransform() {
          this.currentScale = 1;
          this.currentRotation = 0;
          gsap.set(this.$previewImage, {
            scale: 1,
            rotation: 0,
            x: 0,
            y: 0,
          });
          if (this.draggableInstance) {
            this.draggableInstance.update();
          }
        }

        // 计算两点之间的距离
        getDistance(touch1, touch2) {
          const dx = touch1.clientX - touch2.clientX;
          const dy = touch1.clientY - touch2.clientY;
          return Math.sqrt(dx * dx + dy * dy);
        }

        // 修改播放功能
        togglePlay() {
          if (this.isPlayingLocked) return;
          this.isPlayingLocked = true;

          if (!this.isPlaying) {
            this.isPlaying = true;
            if (this.$playBtn) {
              this.$playBtn.querySelector('.play-icon').classList.toggle('hidden');
              this.$playBtn.querySelector('.stop-icon').classList.toggle('hidden');
              this.$playBtn.setAttribute('data-playing', 'true');
            }
            const thumbsContainer = this.querySelector('.thumbsSwiper');
            thumbsContainer.classList.remove('hidden');

            if (!this.slideChangeHandler) {
              this.slideChangeHandler = () => {
                if (this.isPlaying) {
                  this.currentIndex = this.mainSwiper.realIndex;
                  this.animateCurrentSlide();
                }
              };
              this.mainSwiper.on('slideChange', this.slideChangeHandler);
            }

            this.animateCurrentSlide = () => {
              if (!this.isPlaying) return;

              const currentSlide = this.thumbsSwiper.slides[this.currentIndex];
              const borderPath = currentSlide?.querySelector('.border-path');
              const rect = borderPath?.querySelector('rect');

              if (rect) {
                gsap.set(borderPath, { opacity: 1 });
                gsap.fromTo(
                  rect,
                  { strokeDashoffset: 100 },
                  {
                    strokeDashoffset: 0,
                    duration: 2,
                    ease: 'none',
                    onComplete: () => {
                      gsap.to(borderPath, {
                        opacity: 0,
                        duration: 0.3,
                        onComplete: () => {
                          if (this.isPlaying) {
                            this.mainSwiper.slideNext();
                          }
                        },
                      });
                    },
                  }
                );
              }
            };

            this.animateCurrentSlide();
            this.mainSwiper.params.autoplay = {
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            };
            this.mainSwiper.autoplay.start();
          } else {
            this.isPlaying = false;
            if (this.$playBtn) {
              this.$playBtn.querySelector('.play-icon').classList.toggle('hidden');
              this.$playBtn.querySelector('.stop-icon').classList.toggle('hidden');
              this.$playBtn.setAttribute('data-playing', 'false');
            }
            if (this.mainSwiper && this.mainSwiper.autoplay) {
              this.mainSwiper.autoplay.stop();
              const borderPaths = this.thumbsSwiper.el.querySelectorAll('.border-path');
              borderPaths.forEach((path) => {
                const rect = path.querySelector('rect');
                if (rect) {
                  gsap.killTweensOf(rect);
                  gsap.set(rect, { strokeDashoffset: 100 });
                }
                gsap.killTweensOf(path);
                gsap.set(path, { opacity: 0 });
              });
            }
          }

          setTimeout(() => {
            this.isPlayingLocked = false;
          }, 300);
        }

        // 点击mainSwiper区域
        previewImageContainerClick(event) {
          // 检查当前缩放状态
          const isZoomed = this.currentScale !== 1;

          // 检查点击的是否为控制元素
          const isControl =
            event.target.closest('.preview-controls') ||
            event.target.closest('.thumbsSwiper') ||
            event.target.closest('.control-btn');

          // 只有当未缩放且未点击控制元素时才能关闭
          if (!isZoomed && !isControl) {
            const modal = document.querySelector('.preview-modal');
            if (modal) {
              modal.style.display = 'none';
              this.resetTransform();
              this.stopAutoPlay();
              document.body.style.overflow = '';
            }
          }
        }
        stopAutoPlay() {
          if (this.mainSwiper && this.mainSwiper.autoplay) {
            this.mainSwiper.autoplay.stop();
          }
        }
        // 修改旋转函数，修复旋转逻辑
        rotateImage(direction) {
          // 直接累加旋转角度，不需要取模
          this.currentRotation += 90 * direction;

          // 获取当前活动的slide中的图片
          const activeSlide = this.mainSwiper.slides[this.mainSwiper.activeIndex];
          const activeImage = activeSlide.querySelector('img');

          if (activeImage) {
            gsap.to(activeImage, {
              rotation: this.currentRotation,
              duration: 0.3,
            });
          }
        }

        cleanup() {
          if (this.mainSwiper) this.mainSwiper.destroy();
          if (this.thumbsSwiper) this.thumbsSwiper.destroy();
          if (this.hammerInstance) this.hammerInstance.destroy();
          if (this.draggableInstance) this.draggableInstance.kill();
          this.eventListeners.forEach((listener) => listener());
          this.eventListeners.clear();
        }

        // 添加图片预加载函数
        preloadImages(images, index) {
          const preloadCount = 2; // 预加载前后各2张
          const imageUrls = Array.from(images).map((img) => img.src);
          const start = Math.max(0, index - preloadCount);
          const end = Math.min(imageUrls.length, index + preloadCount + 1);

          for (let i = start; i < end; i++) {
            if (i !== index) {
              // 不预加载当前图片
              const img = new Image();
              img.src = imageUrls[i];
            }
          }
        }

        disconnectedCallback() {
          this.cleanup();
        }
      }
    );
  }
});
